import React from 'react';
import './Choose.css';

function Choose() {
  return (
    <div className='choose-outer'>
        <div className="choose-inner">
            <div className="choose-upper">
                <p></p>
                <h2 className="header-text">
                    Why Choose This Course?
                </h2>
            </div>
            <div className="choose-lower">
                <p className="letter-text">
                    The Diploma in Hotel Management is a comprehensive program designed to equip students with the essential skills and knowledge required for a successful career in the hospitality industry. This course covers various aspects of hotel management, including front office operations, food and beverage service, housekeeping, and event management. Students will gain practical experience through internships and hands-on training, preparing them for diverse roles within hotels, resorts, and other hospitality establishments.
                </p>
            </div>
        </div>
    </div>
  )
}

export default Choose
